// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"716":"4fd0abf8","835":"076686da"}[chunkId] + ".chunk.css";
};